// C:\ViYash\XPRSuvey\XPRSuvey-App\src\Utility\userContext.jsx

import { createContext, useContext, useState } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const UserContext = createContext(null);

/**
 * Decodes the JWTToken cookie into a plain user object.
 * NOTE: this is a client-side decode only — no signature verification.
 * Never use userRole from this for authorization checks; that must be
 * enforced server-side. Use it for display purposes only (e.g. UI text).
 */
const decodeUserFromToken = () => {
    const token = Cookies.get("JWTToken");
    if (!token) return null;

    try {
        const payload = jwtDecode(token);
        return {
            userId: payload.UserID,
            userName: payload.UserName,
            userRole: payload.UserRole,
        };
    } catch (err) {
        return null;
    }
};

export function UserProvider({ children }) {
    const [user, setUser] = useState(decodeUserFromToken);

    // Call after login/logout to re-sync state with the current cookie
    const refreshUser = () => setUser(decodeUserFromToken());

    return (
        <UserContext.Provider value={{ user, refreshUser }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    const ctx = useContext(UserContext);
    if (ctx === null) {
        throw new Error("useUser must be used within a UserProvider");
    }
    return ctx;
}